module.exports = __webpack_public_path__ + "static/media/icClose.62d663db.svg";